export default __webpack_public_path__ + "static/media/Madeleine 9781408325001.cbaf79eb.jpg";